module.exports = __webpack_public_path__ + "media/src/public/images/mail/sandbox/sample@3x-31226b43e4123e005c6bf3294bed8494.png";